import axios from "./axios";

export async function fetchPublicJobOpenings(params = {}) {
  return axios({
    method: "get",
    url: "/job_openings/public",
    params,
  })
    .then((response) => response.data)
    .catch((error) => error.response?.data || { error: "Failed to fetch job openings" });
}

export async function fetchPublicJobOpening(id) {
  return axios({
    method: "get",
    url: `/job_openings/${encodeURIComponent(id)}/public`,
  })
    .then((response) => response.data)
    .catch((error) => error.response?.data || { error: "Failed to fetch job opening" });
}

export async function applyToJobOpening(id, payload, file) {
  const formData = new FormData();
  Object.entries(payload || {}).forEach(([key, value]) => {
    if (value === undefined || value === null || value === "") return;
    if (typeof value === "boolean") {
      formData.append(`job_application[${key}]`, value ? "true" : "false");
      return;
    }
    if (Array.isArray(value)) {
      value.forEach((item, index) => {
        if (item && typeof item === "object") {
          Object.entries(item).forEach(([nestedKey, nestedValue]) => {
            if (nestedValue === undefined || nestedValue === null || nestedValue === "") return;
            formData.append(
              `job_application[${key}][${index}][${nestedKey}]`,
              typeof nestedValue === "boolean" ? (nestedValue ? "true" : "false") : nestedValue
            );
          });
          return;
        }
        formData.append(`job_application[${key}][]`, item);
      });
      return;
    }
    formData.append(`job_application[${key}]`, value);
  });
  if (file) {
    formData.append("cv", file);
  }

  return axios({
    method: "post",
    url: `/job_openings/${encodeURIComponent(id)}/public_apply`,
    data: formData,
    transformRequest: [
      (data, headers) => {
        if (data instanceof FormData && headers) {
          if (typeof headers.delete === "function") {
            headers.delete("Content-Type");
          } else {
            delete headers["Content-Type"];
            delete headers["content-type"];
          }
        }
        return data;
      },
    ],
  })
    .then((response) => response.data)
    .catch((error) => error.response?.data || { error: "Failed to submit application" });
}
